// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"b11675e0","114":"441d93ba"}[chunkId] + ".chunk.js";
};